<button
  class="ui-library-item-row"
  type="button"
  [disabled]="disabled()"
  (click)="handleSelected($event)"
>
  <span class="ui-library-item-row-thumb" aria-hidden="true">
    <span
      class="ui-library-item-row-thumb-accent"
      [class.ui-library-item-row-owner-janek]="ownerTone() === 'janek'"
      [class.ui-library-item-row-owner-zosia]="ownerTone() === 'zosia'"
      [class.ui-library-item-row-owner-pawel]="ownerTone() === 'pawel'"
      [class.ui-library-item-row-owner-dom]="ownerTone() === 'dom'"
      [class.ui-library-item-row-owner-neutral]="ownerTone() === 'neutral'"
    ></span>
    @if (hasImage()) {
      <img class="ui-library-item-row-image" [src]="imageUrl()" alt="" />
    } @else {
      <span class="ui-library-item-row-placeholder">
        <ui-library-icon [name]="iconName()" [fallbackLabel]="iconLabel()" />
      </span>
    }
  </span>

  <span class="ui-library-item-row-copy">
    <span class="ui-library-item-row-title-line">
      <span class="ui-library-item-row-title">{{ title() }}</span>
      @if (hasBadge()) {
        <ui-badge tone="accent">{{ badge() }}</ui-badge>
      }
    </span>
    @if (hasSubtitle()) {
      <span class="ui-library-item-row-subtitle">{{ subtitle() }}</span>
    }
  </span>

  <span class="ui-library-item-row-trailing">
    @if (ownerLabelVisible()) {
      <span class="ui-library-item-row-owner-label">{{ ownerLabel() }}</span>
    }
    <ui-avatar
      [initials]="ownerInitials()"
      [label]="ownerLabel()"
      [tone]="ownerTone()"
      [size]="20"
    />
    <span class="ui-library-item-row-chevron" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path d="m9 18 6-6-6-6" />
      </svg>
    </span>
  </span>
</button>
